export default __webpack_public_path__ + "static/media/lean-agile-training-consulting.ae540124.svg";